import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TemaService } from '@core/tema/tema.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class App {
  constructor() {
    // Se instancia acá, en la raíz, y no en el shell: el tema tiene que aplicarse
    // también en el login y en "sin acceso", que están FUERA del shell. Tenerlo
    // sólo en el shell hacía que el modo oscuro se perdiera al cerrar sesión.
    inject(TemaService);
  }
}
